import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import Moments from "moment";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
  Table,
  Badge,
  Alert,
} from "react-bootstrap";
import SVG from "react-inlinesvg";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import AppConfig from "../../../../config/AppConfig";
// const bgImage = toAbsoluteUrl("/media/error/bg5.jpg");
class BentukEvaluasi extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.state = {
      LoadDataSukses: false,
      loading: false,
      showModals: false,
      data: [],
      tautan: [],
      deskripsi: [],
      tanggal_penetapan: [],
      id_jenis_evaluasi: [],
      id_evaluasi: [],
      data_evaluasi: [],
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    };
  }
  onInputChange = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  handleClose() {
    this.setState({
      showModals: false,
      tautan: "",
      tanggal_penetapan: "",
      id_jenis_evaluasi: "",
      id_evaluasi: "",
      deskripsi: "",
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    });
  }
  handleShow(event) {
    this.setState({
      showModals: true,
      id_jenis_evaluasi: event,
    });
  }
  handleEdit(data, jenis) {
    this.setState({
      showModals: true,
      id_ajuan_evaluasi: data.id_ajuan_evaluasi,
      deskripsi: data.deskripsi,
      tautan: data.tautan,
      tanggal_penetapan: Moments(data.tanggal_penetapan).format("YYYY-MM-DD"),
      id_jenis_evaluasi: jenis,
    });
  }
  componentDidMount() {
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session_tahun_siklus = localStorage.getItem("tahun_siklus");
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    axios
      .get(AppConfig.urlGetEvaluasiSiklus + id_sp + "/" + session_tahun_siklus + session)
      .then((res) => {
        this.setState({
          data: res.data.result.evaluasi,
          data_evaluasi: res.data.result.data_evaluasi,
          LoadDataSukses: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          LoadDataSukses: false,
        });
      });
  }
  handleSaveEvaluasi = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        swal({
          title: "Apakah anda yakin?",
          text: "Simpan catatan dari evaluasi yang dilakukan",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        }).then((willDelete) => {
          if (willDelete) {
            this.setState({ loading: true });
            var formData = new FormData();
            formData.append("data[id_ajuan_evaluasi]", this.state.id_evaluasi);
            formData.append("data[tautan]", this.state.tautan);
            formData.append("data[deskripsi]", this.state.deskripsi);
            let session_tahun_siklus = localStorage.getItem("tahun_siklus")
            formData.append("data[tahun_siklus]", session_tahun_siklus);
            formData.append(
              "data[tanggal_penetapan]",
              this.state.tanggal_penetapan
            );
            formData.append("data[status]", 1);
            formData.append(
              "data[id_jenis_evaluasi]",
              this.state.id_jenis_evaluasi
            );
            formData.append("data[id_sp]", sessiondata.i_idunit);
            axios.defaults.headers.post["Content-Type"] =
              "application/x-www-form-urlencoded";
            axios
              .post(AppConfig.urlPostEvaluasi + session, formData)
              .then((res) => {
                swal({
                  title: "Berhasil!",
                  text: "Penyimpanan Evaluasi berhasil!",
                  icon: "success",
                  button: "OK!",
                });
                this.componentDidMount();
                this.setState({
                  LoadDataSukses: false,
                  loading: false,
                  showModals: false,
                  tautan: [],
                  tanggal_penetapan: [],
                  id_jenis_evaluasi: [],
                });
                console.log(res);
              })
              .catch((err) => {
                swal({
                  title: "Gagal!",
                  text: "Penyimpanan evaluasi gagal!",
                  icon: "error",
                  button: "OK!",
                });
                // alert("GAGAL")
                this.setState({
                  LoadDataSukses: false,
                  loading: false,
                  showModals: false,
                });
              });
          }
        });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  handhandleShowHistorical = (jenis) => {
    // console.log(jenis);
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined || id_institusi === null) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(AppConfig.urlGetEvaluasiLainSiklus + id_institusi + "/" + jenis + "/" + tahun_siklus + session)
      .then((res) => {
        console.log(res);
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({
        //   display_edit: false,
        //   showDialogFormSave: false,
        // });
      });
  };
  render() {
    let {
      LoadDataSukses,
      loading,
      showModals,
      tautan,
      deskripsi,
      tanggal_penetapan,
      data,
      data_evaluasi,
    } = this.state;
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let display_evaluasi = [];
    if (LoadDataSukses === true) {
      let penganturan_evaluasi = [];
      for (let i = 0; i < data_evaluasi.length; i++) {
        const val = data_evaluasi[i];
        if (Object.keys(val.evaluasi).length > 0) {
          penganturan_evaluasi.push(
            <>
              <tr>
                <td className="text-left">
                  <label className="checkbox checkbox-md checkbox-light-primary checkbox-single flex-shrink-0">
                    <input type="checkbox" onChange={() => { }} checked={true} />
                    <span></span>
                  </label>
                </td>
                <td>{val.nm_jenis_evaluasi}</td>
                <td>
                  <Button
                    href={val.evaluasi.tautan}
                    target="_blank"
                    className="btn btn-icon btn-light btn-md"
                    style={{
                      minWidth: "50px",
                      borderRadius: "12px",
                      background: "#A9C6DE",
                    }}
                  >
                    <i
                      class="flaticon-attachment"
                      style={{ color: "#3F4254", fontSize: "14px" }}
                    ></i>
                  </Button>
                </td>
                <td className="text-center">
                  <Moment
                    date={val.evaluasi.tanggal_penetapan}
                    format="DD/MM/YYYY"
                  />
                </td>
                <td className="text-center">
                  <Moment date={val.evaluasi.created_at} format="DD/MM/YYYY" />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    verticalAlign: "middle",
                  }}
                >
                  {val.evaluasi.statusajuan === 3 ? (
                    <Badge
                      pill
                      variant="success"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      <Badge variant="light">
                        {" "}
                        <span style={{ color: "#37bf30" }}>✔</span>
                      </Badge>
                      &nbsp;&nbsp;&nbsp; Terverifikasi
                    </Badge>
                  ) : (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Belum Terverifikasi
                    </Badge>
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    verticalAlign: "middle",
                  }}
                >
                  {val.evaluasi.statusdokumen === 1 ? (
                    <Badge
                      pill
                      variant="success"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      <Badge variant="light">
                        {" "}
                        <span style={{ color: "#37bf30" }}>✔</span>
                      </Badge>
                      &nbsp;&nbsp;&nbsp; Sudah Valid
                    </Badge>
                  ) : val.evaluasi.statusdokumen === 0 ? (
                    <Badge
                      pill
                      variant="warning"
                      style={{
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Belum Valid
                    </Badge>
                  ) : (
                    <Badge
                      pill
                      variant="secondary"
                      style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
                    >
                      Dokumen belum diverifikasi
                    </Badge>
                  )}
                </td>
                <td className="text-center">
                  {userdata.i_idrole === 10 ||
                    userdata.i_idrole === 2013 ||
                    userdata.i_idrole === 2014 ? (
                    <Link
                      to={
                        "/ajuan-evaluasi/detail/" +
                        val.evaluasi.id_ajuan_evaluasi
                      }
                    >
                      <Button
                        className="btn btn-icon btn-primary btn-sm"
                        style={{ minWidth: "50px", borderRadius: "12px" }}
                      >
                        <i
                          class="flaticon-eye"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </Link>
                  ) : userdata.i_idrole === 3 ? (
                    <>
                      <Link
                        to={
                          "/ajuan-evaluasi/detail/" +
                          val.evaluasi.id_ajuan_evaluasi
                        }
                      >
                        <Button
                          className="btn btn-icon btn-primary btn-sm"
                          style={{
                            minWidth: "50px",
                            borderRadius: "12px",
                          }}
                        >
                          <i
                            class="flaticon-eye"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                          ></i>
                        </Button>
                      </Link>
                      {/* {val.evaluasi.statusajuan === 1 || (val.evaluasi.statusdokumen === 0 || val.evaluasi.statusdokumen === "null") ? ( */}
                      <Button
                        onClick={() =>
                          this.handleEdit(val.evaluasi, val.id_jenis_evaluasi)
                        }
                        className="btn btn-icon btn-warning btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          color: "#fff",
                          marginLeft: "5px",
                        }}
                      >
                        <i
                          class="flaticon-edit"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                      </Button>
                      {/* ) : ( "" )} */}
                    </>
                  ) : (
                    ""
                  )}
                  <Button
                    onClick={() =>
                      this.handhandleShowHistorical(
                        val.evaluasi.id_jenis_evaluasi
                      )
                    }
                    className="btn btn-icon btn-success btn-sm"
                    style={{
                      minWidth: "50px",
                      borderRadius: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    <i
                      class="flaticon2-time"
                      style={{ color: "#ffffff", fontSize: "14px" }}
                    ></i>
                  </Button>
                </td>
              </tr>
            </>
          );
        } else {
          penganturan_evaluasi.push(
            <>
              <tr>
                <td className="text-left">
                  <label className="checkbox checkbox-md checkbox-light-primary checkbox-single flex-shrink-0">
                    <input
                      type="checkbox"
                      onChange={() => { }}
                      checked={false}
                    />
                    <span></span>
                  </label>
                </td>
                <td>{val.nm_jenis_evaluasi}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                {userdata.i_idrole === 3 ? (
                  <td class="text-center">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-bottom`}>
                          <div style={{ textAlign: "left" }}>
                            Atur Pengaturan
                          </div>
                        </Tooltip>
                      }
                    >
                      <Button
                        onClick={() => this.handleShow(val.id_jenis_evaluasi)}
                        className="text-center btn btn-primary btn-sm"
                        style={{
                          float: "center",
                          minWidth: "50px",
                          borderRadius: "12px",
                          fontSize: "12px",
                        }}
                      >
                        <i class="fa fa-cog" style={{ fontSize: "14px" }}></i>
                      </Button>
                    </OverlayTrigger>
                  </td>
                ) : (
                  ""
                )}
              </tr>
            </>
          );
        }
      }
      display_evaluasi = <>{penganturan_evaluasi}</>;
    } else {
      display_evaluasi = (
        <>
          <tr>
            <td colSpan="8">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }

    let display_historical = [];
    if (this.state.loadingHistorical === true) {
      this.state.data_historical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "left" }}>
                {list.keterangan !== "null" ? (
                  list.keterangan
                ) : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tautan !== "null" ? (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-success btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                ) : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : list.statusajuan === 1 ? (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    -
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tanggal_penetapan === "null" ? (
                  "-"
                ) : (
                  <Moment
                    format="DD/MM/YYYY"
                    date={
                      list.tanggal_penetapan === "null"
                        ? "-"
                        : list.tanggal_penetapan
                    }
                  />
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.catatan === "null" ? "-" : list.catatan}
              </td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    return (
      <>
        <div className="">
          <div className="table-responsive" bordered={false}>
            <table
              className="table  table-vertical-center"
              id="kt_advance_table_widget_1"
            >
              <thead>
                <tr
                  className="text-left text-white"
                  style={{ backgroundColor: "#3047ad" }}
                >
                  <th>
                    <span className="svg-icon svg-icon-lg svg-icon-white">
                      <SVG
                        className="h-75 align-self-end"
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg"
                        )}
                      ></SVG>
                    </span>
                  </th>
                  <th style={{ minWidth: "150px", textTransform: "uppercase" }}>
                    Laporan Pelaksanaan dan Hasil Evaluasi
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    <ButtonToolbar>
                      TAUTAN
                      {["bottom"].map((placement) => (
                        <OverlayTrigger
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip id={`tooltip-${placement}`}>
                              <div style={{ textAlign: "left" }}>
                                Jika pengaturan tautan masih dalam berbentuk
                                soft file, pdf, dll, maka Perguruan Tinggi harus
                                menggunggah terlebih dahulu file tersebut dengan
                                menggunakan layanan penyimpanan online. Contoh{" "}
                                <em style={{}}> Dropbox, Google Drive dll</em>
                              </div>
                            </Tooltip>
                          }
                        >
                          <div>
                            &nbsp;&nbsp;
                            <span
                              style={{ fontSize: "15px" }}
                              className="text-white fa fa-info-circle"
                            ></span>
                          </div>
                        </OverlayTrigger>
                      ))}
                    </ButtonToolbar>
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    TANGGAL TERAKHIR DILAKUKAN
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    TANGGAL DIPERBARUI
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    STATUS VERIFIKASI
                  </th>
                  <th className="text-center" style={{ minWidth: "150px" }}>
                    STATUS DOKUMEN
                  </th>
                  <th className="text-center" style={{ minWidth: "180px" }}>
                    <span style={{ marginRight: "10px" }}>AKSI</span>
                  </th>
                </tr>
              </thead>
              <tbody>{display_evaluasi}</tbody>
              <br />
              {/* END BENTUK EVALUASI` */}
              {/* BEGIN AUDIT MUTU INTERNAL` */}
              {/* END :: AUDIT MUTU INTERNAL` */}
            </table>
          </div>
          {/* end::Table */}
        </div>
        <div className="card-body py-0">
          {/* begin::Table */}
          <div className="table-responsive" bordered={false}>
            <table
              className="table  table-vertical-center"
              id="kt_advance_table_widget_1"
            ></table>
          </div>
          {/* end::Table */}
        </div>
        <Modal size="lg" show={showModals} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Catatan dari evaluasi yang dilakukan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal terakhir evaluasi yang dilakukan{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={tanggal_penetapan}
                onChange={(e) => this.onInputChange(e, "tanggal_penetapan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleSaveEvaluasi}
                disabled={loading}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          show={this.state.showHistorical}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Riwayat Pengaturan Evaluasi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <th style={{ textAlign: "center" }}>Deskripsi</th>
                <th style={{ textAlign: "center" }}>Tautan</th>
                <th style={{ textAlign: "center" }}>Status Verfikasi</th>
                <th style={{ textAlign: "center" }}>Tanggal Penetapan</th>
                <th style={{ textAlign: "center" }}>Catatan</th>
              </thead>
              <tbody>{display_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default BentukEvaluasi;
